import React from 'react';

import Icon from '@wetransfer/transfer/component/icon';
import { Button } from '@wetransfer/transfer/oneui/react';

import { MobileWebActionsProps } from './types';

export const MobileWebActions = React.memo(function MobileWebActions({
  showSecondaryButton,
  onSecondaryButtonClick,
  onPrimaryButtonClick,
}: MobileWebActionsProps) {
  return (
    <>
      {showSecondaryButton && onSecondaryButtonClick && (
        <Button
          variant="secondary"
          className="downloader__download-button downloader__share-button"
          onClick={onSecondaryButtonClick}
          data-testid="mobileWebActions-secondaryButton"
        >
          <Icon type="Share" />
        </Button>
      )}
      <Button
        variant="primary"
        className="downloader__download-button"
        onClick={onPrimaryButtonClick}
        data-testid="mobileWebActions-primaryButton"
      >
        <Icon type="DownloadArrowUnderscored" />
      </Button>
    </>
  );
});
